import React from 'react';
import axios from 'axios';
import { ApiBaseUrlContext } from '../App';
import { ReactComponent as RemoveItemIcon } from '../assets/svg/icon-remove-1.svg';

const UploadedFileItem = ({ file, machineid, onFileRemoved }) => {
  const apiBaseUrl = React.useContext(ApiBaseUrlContext);
  // Extract the filename from the file path
  const filename = file.path.split('/').pop();

  const handleRemove = () => {
    if (!window.confirm('Are you sure you want to remove this file?')) {
      return;
    }
    axios
      .delete(`${apiBaseUrl}/mnt/api/machines/${machineid}/file`, {
        data: { filename } // Adjust if your backend expects file.path instead
      })
      .then(response => {
        alert('File removed successfully');
        // Notify the parent component to update the UI.
        onFileRemoved(filename);
      })
      .catch(error => {
        console.error('Error removing file:', error);
        alert('Error removing file');
      });
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
      <a href={file.path} target="_blank" rel="noopener noreferrer" style={{ flex: 1 }}>
        {file.title}
      </a>
      <button 
        type="button" 
        onClick={handleRemove} 
        style={{ marginLeft: '10px', background: 'transparent', border: 'none', cursor: 'pointer' }}
      >
        <RemoveItemIcon />
      </button>
    </div>
  );
};

export default UploadedFileItem;
